import { jsx } from '@amazon/vinyl-tsx'
import { createDisposer } from '@amazon/vinyl-util'
import { data, type MutableValue } from '@amazon/vinyl-observable'
import { signedIn } from '@/auth/authRef'
import { getUserInfo, pickProfileImageUrl } from '@/customer/service/userInfoService'
import { getString } from '@/header/i18n/bundle.generated'
import { reportShellClick } from '@/metrics/shellUiMetrics'

export function ProfileAvatarButton(props: {
    headerMenuVisible: MutableValue<boolean>
    // Extra class tokens for callers that need to size/position the shared
    // avatar (e.g. the mobile top bar) without forking the component.
    className?: string
}) {
    const imageUrl$: MutableValue<string | null> = data<string | null>(null)

    const view = (
        <button
            className={`profileAvatar button${props.className ? ` ${props.className}` : ''}`}
            tabIndex={0}
            onclick={(event) => {
                event.stopImmediatePropagation()
                const opening = !props.headerMenuVisible.value
                if (opening) {
                    reportShellClick({ actionType: 'showSettingsOverflow', interactionType: 'TAP' })
                }
                props.headerMenuVisible.value = opening
            }}
            visible={signedIn()}
            aria-label={getString('dmusic_header_profile_menu_label')}
            title={getString('dmusic_header_profile_menu_label')}
            aria-haspopup="menu"
            aria-expanded={props.headerMenuVisible.map((v) => (v ? 'true' : 'false'))}
            onConnect={() => {
                const { add, dispose } = createDisposer()
                // Subscribe to the shared user-info observable so the
                // avatar reflects edits (avatar/name) immediately,
                // including overlay-driven optimistic updates from the
                // profile page.
                add(
                    signedIn().onData((isIn) => {
                        if (!isIn) imageUrl$.value = null
                    })
                )
                add(
                    getUserInfo().onData((info) => {
                        if (!signedIn().value || !info) {
                            imageUrl$.value = null
                            return
                        }
                        imageUrl$.value = pickProfileImageUrl(info)
                    })
                )
                add(
                    imageUrl$.onData((url) => {
                        view.style.backgroundImage = url ? `url("${url}")` : ''
                        view.classList.toggle('hasImage', !!url)
                    })
                )
                return dispose
            }}
        />
    )
    return view
}
